module.exports = __webpack_public_path__ + "img/delete.3f1c641d.svg";